import moment from 'moment'
import { calculateMonthsDifference } from './general'

export type TimeOffBucket = 'past' | 'near' | 'mid' | 'far'

export const TIMEFRAME_LABELS: Record<TimeOffBucket, string> = {
  past: 'Past',
  near: '0-2 months',
  mid: '3-6 months',
  far: '+6 months',
}

export const classifyTimeOffBucket = (
  clippedEndDate: moment.Moment,
  originalStartDate: string | Date,
): TimeOffBucket => {
  if (clippedEndDate.isBefore(moment())) return 'past'

  const months = calculateMonthsDifference(
    new Date().toISOString(),
    originalStartDate as string,
  )
  if (months <= 2) return 'near'
  if (months <= 6) return 'mid'
  return 'far'
}
